var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 665,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92 -754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.169 997.203 284.378 993.994 218.489 830.571 369.122 930.957 416.942 761.572 476.462 927.208 619.726 816.56 565.397 984.18 749.381 974.532 601.957 1080.11 756.387 1175.15 572.178 1178.36 638.067 1341.78 487.434 1241.4 439.613 1410.78 380.094 1245.15 236.83 1355.8 291.159 1188.17 107.175 1197.82 254.599 1092.24Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#9142FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.413 1032.79 341.938 1030.87 302.404 932.814 392.784 993.045 421.477 891.414 457.188 990.796 543.147 924.407 510.549 1024.98 620.94 1019.19 532.485 1082.54 625.143 1139.56 514.618 1141.49 554.151 1239.54 463.771 1179.31 435.079 1280.94 399.367 1181.56 313.409 1247.95 346.006 1147.38 235.616 1153.16 324.071 1089.82Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FE9FB3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco4);
export default __webpack_public_path__ + "static/media/deco4.4005e7f9d81de7931395ae611ff6ff5d.svg";
export { ForwardRef as ReactComponent };